import React, { Component } from 'react';
import { Table, Pager, Pagination } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Checkbox from '../../Checkbox';
import '../../../content/css/PortfolioAnalysis/PortfolioAnalysisDocumentsTable.css';

export default class DocumentsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            totalPages: Math.ceil(this.props.items.length / 20)
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.items != prevProps.items) {
            this.setState({ totalPages: Math.ceil(this.props.items.length / this.props.itemsPerPage) });
        }
    }

    getContractTypeName = (type) => {
        switch (type) {
            case 0: return "Procurement agreement";
            case 1: return "Customer agreement";
            case 2: return "Unknown";
            case 3: return "NDA - receiving information";
            case 4: return "NDA - giving information";
            case 5: return "NDA - giving/receiving information";
            case 6: return "EULA - Customer";
            case 7: return "Terms & conditions";//"EULA - Seller";
            case 8: return "Distribution agreement - Customer";
            case 9: return "Distribution agreement - Seller";
            case 10: return "DPA - Controller";
            case 11: return "DPA - Processor";
            case 12: return "License agreement - Customer";
            case 13: return "License agreement - Seller";
            case 14: return "Source of Goods agreement";
        }
    }

    ticksToDateString = (ticks) => {
        const ticksPerMillisecond = 10000;
        const epochTicks = 621355968000000000; // number of ticks between .NET epoch (January 1, 0001) and Unix epoch (January 1, 1970)
        let javascriptTimestamp = (ticks - epochTicks) / ticksPerMillisecond;
        let date = new Date(javascriptTimestamp);
        return date.toLocaleDateString();
    }

    handleIsSelected = (id, isActive) => {
        this.props.onSelect(id, isActive);
    }

    gotoPage = (page) => {
        page = Math.max(Math.min(page, this.state.totalPages), 0);
        this.setState({ activePage: page });
        this.props.onPageUpdate(page);
    }

    isSelected = (id) => {
        return this.props.selectedItems.includes(id);
    }

    renderItems = () => {
        if (this.props.items == null)
            return [];

        const startIndex = (this.state.activePage - 1) * this.props.itemsPerPage;
        const endIndex = startIndex + this.props.itemsPerPage;

        //return this.props.items.slice(startIndex, endIndex).map((x, index) =>
        return this.props.items.map((x, index) =>
            <tr>
                <td><Link to={`/${x.id}/viewer/1`}>{x.fileName}</Link></td>
                {/*<td>{this.getContractTypeName(x.contractType)}</td>*/}
                <td className="nowrap">{new Date(x.wasSaved).toLocaleDateString()}</td>
                <td><Checkbox value={this.isSelected(x.id)} onChange={(isSelected) => this.handleIsSelected(x.id, isSelected)} /></td>
            </tr>
        );
    }

    renderPagination() {
        const totalPages = this.state.totalPages;
        const activePage = this.state.activePage;

        let startPage = Math.max(1, activePage - 2);
        let endPage = Math.min(totalPages, activePage + 2);

        // Adjust startPage and endPage if there are not enough pages to show 5 pages
        if (endPage - startPage < 4) {
            if (activePage <= 3) {
                endPage = Math.min(startPage + 4, totalPages);
            } else {
                startPage = Math.max(endPage - 4, 1);
            }
        }

        const paginationItems = [];
        for (let page = startPage; page <= endPage; page++) {
            paginationItems.push(
                <Pagination.Item key={page} active={page === this.state.activePage} onClick={() => this.gotoPage(page)}>
                    {page}
                </Pagination.Item>
            );
        }

        return paginationItems;
    }

    render() {
        return (
            <div>
                <Table className="documents-table" hover>
                    <thead>
                        <tr>
                            <th>Filename</th>
                            {/*<th>Contract type</th>*/}
                            <th>Date</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderItems()}
                    </tbody>
                </Table>
                {/*<Pager>
                    <Pagination.Prev onClick={() => this.gotoPage(this.state.activePage - 1)} />
                    <Pagination.Item onClick={() => this.gotoPage(1)}>{1}</Pagination.Item>
                    <Pagination.Ellipsis />
                    {this.renderPagination()}
                    <Pagination.Ellipsis />
                    <Pagination.Item onClick={() => this.gotoPage(this.state.totalPages)}>{this.state.totalPages}</Pagination.Item>
                    <Pagination.Next onClick={() => this.gotoPage(this.state.activePage + 1)} />
                </Pager>
                */}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/NewPortfolioAnalysis/DocumentsTable.js